import React from "react";

import { RoundNotifyMeButton } from "@faire/retailer/components/RoundNotifyMeButton";
import { useSubscribedBackInStockToken } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/useSubscribedBackInStockToken";
import { NotifyMeWrapper } from "@faire/retailer/features/MarketplaceItems/styled";

import { NotifyMeProps } from "./NotifyMeProps";

export const NotifyMeBackInStockButton: React.FC<NotifyMeProps> = ({
  productOptionToken,
  productToken,
}) => {
  const { isSubscribedToBackInStock, deleteBackInStockNotification } =
    useSubscribedBackInStockToken(productOptionToken ?? "");
  return (
    <NotifyMeWrapper
      onClick={(e) => e.preventDefault()}
      key={`${productToken}-round-notify-me-picker`}
    >
      <RoundNotifyMeButton
        productOptionToken={productOptionToken ?? ""}
        isSubscriedToBackInStock={isSubscribedToBackInStock}
        deleteBackInStockNotification={deleteBackInStockNotification}
      />
    </NotifyMeWrapper>
  );
};
